// import React, { useRef, useState, useCallback } from 'react';
// import Webcam from 'react-webcam';
// import { Box, Button, Grid } from '@material-ui/core';
// import { useDispatch } from 'react-redux';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { PVuploadFile } from '../../ReduxStore/CreatePlanSlice';

// const WebcamCapture = ({ onCapture }) => {
//     const dispatch = useDispatch();
//     const webcamRef = useRef(null);
//     const [imgSrc, setImgSrc] = useState(null);
//     const [location, setLocation] = useState(null);

//     // const getLocation = () => {
//     //     if (navigator.geolocation) {
//     //         navigator.geolocation.getCurrentPosition((position) => {
//     //             console.log("location", position.coords.latitude, position.coords.longitude)
//     //             setLocation({
//     //                 latitude: position.coords.latitude,
//     //                 longitude: position.coords.longitude
//     //             });
//     //         });
//     //     } else {
//     //         console.error("Geolocation is not supported by this browser.");
//     //     }
//     // };

//     const capture = useCallback(() => {
//         const imageSrc = webcamRef.current.getScreenshot();
//         // getLocation();
//         setImgSrc(imageSrc);
//         // onCapture(imageSrc);
//     }, [webcamRef, onCapture]);

//     const handleCapture = async (imageSrc, location) => {
//         console.log("imge", imageSrc)
//         const dataURItoBlob = (dataURI) => {
//             const byteString = atob(dataURI.split(',')[1]);
//             const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

//             const ab = new ArrayBuffer(byteString.length);
//             const ia = new Uint8Array(ab);

//             for (let i = 0; i < byteString.length; i++) {
//                 ia[i] = byteString.charCodeAt(i);
//             }

//             return new Blob([ab], { type: mimeString });
//         };
//         const file = dataURItoBlob(imageSrc)
//         const customerID = "30fa3d2e687748999daf40a5a9176e4c"
//         const formData = new FormData();
//         formData.append('file',file);
//         // formData.append('upload_file', file);
//         // formData.append('customerID', customerID)
//         console.log("file", file)
//         const action = dispatch(PVuploadFile(formData));
//         const res = await action.unwrap();
//         console.log("res fromIMAGE:", res, res.response.location);
//         if (res.StatusCode === 200) {
//             toast.success("Image Upload Done");
//         } else {
//             toast.error("Something went wrong!")
//         }
//     };

//     return (
//         <Box>
//             <img src="https://api.escuelajs.co/api/v1/files/1022b" alt=""/>
//             {!imgSrc ? (
//                 <>
//                     <Webcam
//                         audio={false}
//                         ref={webcamRef}
//                         screenshotFormat="image/jpeg"
//                         width="100%"
//                     />
//                     <Button variant="contained" color="primary" onClick={capture}>
//                         Capture
//                     </Button>
//                 </>
//             ) : (
//                 <Box>
//                     <img src={imgSrc} alt="captured" />
//                     <Grid container spacing={2}>
//                         <Grid item xs={6}>
//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 fullWidth
//                                 // onClick={() => onCapture(imgSrc, location)}
//                                 onClick={() => handleCapture(imgSrc, location)}
//                             >
//                                 Upload
//                             </Button>
//                         </Grid>
//                         <Grid item xs={6}>
//                             <Button
//                                 variant="contained"
//                                 fullWidth
//                                 style={{ color: 'black', background: 'white' }}
//                                 onClick={() => setImgSrc(null)}
//                             >
//                                 Retake
//                             </Button>
//                         </Grid>
//                     </Grid>
//                 </Box>
//             )}
//             <ToastContainer />
//         </Box>
//     );
// };

// export default WebcamCapture;


import React, { useRef, useState, useCallback } from 'react';
import Webcam from 'react-webcam';
import { Box, Button, Grid } from '@material-ui/core';
// import { useDispatch } from 'react-redux';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { PVuploadFile } from '../../ReduxStore/CreatePlanSlice';

const WebcamCapture = ({ onCapture }) => {
    // const dispatch = useDispatch();
    const webcamRef = useRef(null);
    const [imgSrc, setImgSrc] = useState(null);

    // Function to determine the facing mode
    const getFacingMode = () => {
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        return isMobile ? "environment" : "user";
    };

    const capture = useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        setImgSrc(imageSrc);
    }, [webcamRef]);

    return (
        <Box>
            {!imgSrc ? (
                <>
                    <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width="100%"
                        videoConstraints={{
                            facingMode: getFacingMode(), // Use dynamic facing mode
                        }}
                    />
                    <Button variant="contained" color="primary" onClick={capture}>
                        Capture
                    </Button>
                </>
            ) : (
                <Box>
                    <img src={imgSrc} alt="captured" />
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => onCapture(imgSrc)}
                            // onClick={() => handleCapture(imgSrc)}
                            >
                                Upload
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button
                                variant="contained"
                                fullWidth
                                style={{ color: 'black', background: 'white' }}
                                onClick={() => setImgSrc(null)}
                            >
                                Retake
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </Box>
    );
};

export default WebcamCapture;
